// import { Dropdown } from "@trussworks/react-uswds";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import {
    SearchFilters
  } from "../../types/v1_schemas";
import { AxiosResponse } from "axios";
import i18n from "../../i18n";
import { QueryLookupTablesApi } from "../../utils/QueryHelper";
import TypeOfHelpInput from "../Search/Filters/TypeOfHelpInput";

const DivWithLabel = styled.div`
  display: flex;
  margin-left:65px;
  font-family: Comfortaa;
  font-weight: bold;
  font-size:32px;
  letter-spacing:-3%;
`;

const StyledSpan = styled.span`
  color: dark_blue!important;
  `

const DropdownToggle = styled(Dropdown.Toggle as any)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  background-color: white;
  height: 50px;
  border-width: 1px;
  border-radius: 0.25rem;
  border-color: #1A103F;
  width: 350px;
  @media (max-width: 700px) {
    width: 100%;
  }

  &:hover,
  &:focus {
    background-color: white;
    color: #71767a;
    border-color: #565c65;
  }

  &.show {
    color: white !important;
  }
`;

const DropdownMenu = styled(Dropdown.Menu as any)`
  width: 350px;
  @media (max-width: 700px) {
    width: 100%;
  }
`;

const DropdownElement = styled(Dropdown as any)`
`;

const DropdownItem = styled(Dropdown.Item as any)`
`;

const serviceMatch = ["Withdrawal management (i.e. detox)", "Manejo de la abstinencia (es decir, desintoxicación)", 
        "Screening and early prevention for mental health", "Detección y prevención temprana de problemas de salud mental",
        "Walk-in crisis services", "Servicios sin cita previa en caso de crisis",
        "Opioid use disorder treatment", "Tratamiento de trastornos por consumo de opioides",
        "Residential for mental health", "Residencias para la salud mental",
        "Residential for substance use", "Residencias por el consumo de sustancias",
        "DUI Level I/II Education and Therapy", "Educación y terapia de nivel I/II por DUI"];

type ApiServiceProvided = {
  id: number;
  categoryId: number;
  plainLanguageEn: string;
  plainLanguageEs: string;
  textEn: string;
  textEs: string;
};

export type ResponseServiceProvided = {
  id: string;
  categoryId: number;
  plainLanguage: string;
  text: string;
};

function TypeOfHelpDropDown({
  filters,
  setFilters: setServicesProvided,
}: {
  filters: SearchFilters;
  setFilters: Dispatch<SetStateAction<SearchFilters>>;
}) {
  const { t } = useTranslation();

  return (
    <DropdownElement
      id="type-of-help-dropdown"
      defaultValue=""
      aria-label={t("dropdownPrompt")}
    >
 
      <DropdownToggle
        className={!!filters.serviceProvidedIds?.length ? "text-black text-wrap" : "text-base text-wrap"}
      >
 
          {t("dropdownPrompt")}
      </DropdownToggle>
      <DropdownMenu>
        <div className="padding-2">
          <TypeOfHelpInput
            legend={""}
            filters={filters}
            setFilters={setServicesProvided}
          />
        </div>
      </DropdownMenu>
    </DropdownElement>
  );
}

export default TypeOfHelpDropDown;
